export default __webpack_public_path__ + "static/media/estrutura5.edd37552.jpg";